export const ListQueryKey = 'shoppingAddresss';
export const DetailQueryKey = 'shoppingAddress';

export const Urls = {
  selectUrl: '/shoppingAddress/list',
  updateUrl: '/shoppingAddress/update',
  deleteUrl: '/shoppingAddress/delete',
  createUrl: '/shoppingAddress/create',
  detailUrl: '/shoppingAddress/detail',
};
